import { Box, Stack } from '@mui/material';
import styled from 'styled-components';

export const MainContainer = styled(Box)({
  width: '100%',
  height: 'calc(100vh / var(--zoom))',
  overflowY: 'auto',
});

export const AssetsContainer = styled(Box)({
  width: '85%',
  color: '#435C7A',
  margin: '2rem auto 5rem auto',
});

export const ContainerBox = styled(Stack)((bgColor) => ({
  padding: '2.4rem 1.6rem',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
  backgroundColor: `${bgColor}`,
  borderRadius: '0.4rem',
  overflow: 'hidden',
  gap: '0.8rem',
}));
